import React, { useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { Button, Col, Row, Table, Input, Space, Card, Popconfirm } from "antd";
import { crmService } from "../services/crm.service";
import {
  SearchOutlined,
  SendOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

function PageForEmbbed() {
  const [tableValue, setTableValue] = useState([]);
  const [formSaved, setFormSaved] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [loading, setLoading] = useState(true);
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),

    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput?.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...getColumnSearchProps("name"),
      render: (text) => (
        <p>{text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}</p>
      ),
      fixed: "left",
    },
    {
      title: "Cognome",
      dataIndex: "surname",
      key: "surname",
      sorter: (a, b) => a.surname.localeCompare(b.surname),
      ...getColumnSearchProps("surname"),
      render: (text) => (
        <p>{text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}</p>
      ),
      fixed: "left",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) =>
        a.email != null && b.email != null
          ? a.email.localeCompare(b.email)
          : null,
      ...getColumnSearchProps("email"),
      render: (text) => <a href={`mailto:${text}`}>{text.toLowerCase()}</a>,
    },
    {
      title: "Telefono",
      dataIndex: "phone",
      key: "phone",
      render: (text) => <p> {text === "" ? "-" : `${text}`}</p>,
    },
    {
      title: "Provenienza",
      dataIndex: "idSite",
      key: "idSite",
      render: (a, b, c) => (
        <p>{a.idSite === null ? "Web" : "Form Sito Alessi"}</p>
      ),
    },
    {
      title: "Data inserimento in CRM",
      dataIndex: "crmDate",
      key: "crmDate",
      render: (text) => <p>{text ? `${text}` : "Non inviato"}</p>,
    },
    {
      title: "Azioni",
      dataIndex: "",
      key: "x",
      render: (a, b, c) => (
        <Row gutter={3}>
          <Col span={12}>
            <Popconfirm
              title="Creazione Lead CRM"
              description={"Sei sicuro di volerla creare?"}
              onConfirm={() => sendToCRM(a)}
              okText="Si"
              cancelText="No"
            >
              <Button
                type="link"
                icon={<SendOutlined />}
                disabled={a.crmDate != null}
              />
            </Popconfirm>
          </Col>
          <Col span={12}>
            <Popconfirm
              title="Elimina Possibile Lead"
              description="Sei sicuro di volerla eilminare?"
              onConfirm={() => {
                crmService.detetePossibleLead(a.id);
                getTable();
              }}
              okText="Si"
              cancelText="No"
            >
              <Button danger type="text" icon={<DeleteOutlined />} />
            </Popconfirm>
          </Col>
        </Row>
      ),
      fixed: "right",
    },
  ];

  useEffect(() => {
    getTable();
  }, [formSaved]);

  function getTable() {
    crmService.getPossibleLead().then((res) => {
      setTableValue(res);
      setFormSaved(false);
      setLoading(false);
    });
  }

  function sendToCRM(lead) {
    crmService.saveLead(lead);
    getTable();
  }
  return (
    <>
      <Row>
        <Col></Col>
      </Row>
      <Card style={{ width: "100wh" }} size="small">
        <Table
          loading={loading}
          size="small"
          rowKey="id"
          columns={columns}
          dataSource={tableValue}
          pagination={{ defaultCurrent: 1 }}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
}
export default PageForEmbbed;
